import Box from '@mui/material/Box';
import React from 'react';
import PropTypes from 'prop-types';

const FullHeightBox = ({ children, ...restBoxProps }) => (
  <Box
    height="100%"
    display="flex"
    flexDirection="column"
    {...restBoxProps}
  >
    {children}
  </Box>
);

FullHeightBox.propTypes = {
  children: PropTypes.node,
};
FullHeightBox.defaultProps = {
  children: null,
};

export default FullHeightBox;
